import { formatToCurrency } from '@/lib/helpers';
import { ToWords } from 'to-words';
const toWords = new ToWords({ localeCode: 'en-US' });

export const generateGuaranteeDoc = ({ loan, company }) => {
  const companyName = company.name;
  const companyShortName = company.shortName;
  loan.loanAmountInWords = toWords
  .convert(loan?.loanAmount || 0, { currency: true, doNotAddOnly: true })
  .toUpperCase();
  loan.loanAmountInCurrency = formatToCurrency(loan.loanAmount);

  const config = {
    info: {
      title: 'Guarantee', // name of the document being printed
      modDate: new Date(), // date the document was last modified
      creationDate: new Date(), // date the document was created
      keywords: 'guarantee, loan, finance', // keywords associated with the document
      author: 'Sodality Co-operative Credit Union Limited', // company name
      subject: 'Guarantee', // name of the document being printed
      creator: 'John Doe', // name of the logged in user
      producer: 'Sodality Co-operative Credit Union Limited' // company name
    },

    defaultStyle: {
      font: 'Lora',
      color: '#0f172a',
      fontSize: 11,
      lineHeight: 1.3
    },

    content: [
      {
        text: ` ${companyName} `,
        margin: [0, 0, 0, 5],
        alignment: 'center',
        bold: 'true'
      },
      {
        text: 'GUARANTEE',
        margin: [0, 0, 0, 40],
        alignment: 'center',
        bold: 'true'
      },
      {
        text: `TO: ${companyName}`,
        style: 'header',
        margin: [0, 0, 0, 20],
        bold: 'true'
      },
      {
        text: [ 
          'IN CONSIDERATION of the',
          {
            text: ` ${companyName} `,
            bold: true,
          },
          '(herein referred to as “',
          {
            text: ` ${companyShortName} `,
            bold: true
          },
          '”) agreeing to the loan request of  MARCIA BROWN-ELLIOTT (herein referred to as the “BORROWER”) in the way of its business as a co-operative society the undersigned and each of them, if more than one, hereby jointly and severally guarantee(s) payment to',
          {
            text: ` ${companyShortName} `,
            bold: true, 
          },
          'of all GUARANTEED LIABILITIES in regards to the sum of',
          {
            text: ` ${loan.loanAmountInWords} (${loan.loanAmountInCurrency}) `,
            bold: true,
          },
          'with interest from the date of demand of payment at the rates mentioned in paragraph 5 hereof.',
        ],
        margin: [0, 0, 0, 10]
      },
      {
        text: [
          'AND THE UNDERSIGNED and each of them, if more than one, hereby jointly and severally agree with',
          {
            text: ` ${companyShortName} `,
            bold: true
          },
          'as follows:',
        ],
        margin: [0, 0, 0, 10]
      },
      {
        ol: [
          [
            {
              text: 'DEFINITION AND INTERPRETATION:',
              margin: [0, 0, 0, 10],
              decoration: 'underline'
            },
            {
              ol: [
                [
                  'In this guarantee the words',
                  {
                    ol: [
                      [
                        'GUARANTOR” shall mean the undersigned and, if there is more than one GUARANTOR, it shall mean each of them, and their liability hereunder shall be a joint and several liability.'
                      ],
                      [
                        'Guaranteed Liabilities” shall mean: in its most comprehensive sense without limitation any and allpayment obligations, debts and liabilities:',
                        {
                          ol: [
                            ['present or future; or'],
                            ['direct or indirect;'],
                            ['absolute or contingent;'],
                            ['matured or not;'],
                            [
                              {
                                text: [
                                  'at any time owing by the BORROWER to',
                                  { 
                                    text: ` ${companyShortName} `,
                                    bold: true,
                                  },
                                  'or remaining unpaid to',
                                  { 
                                    text: ` ${companyShortName} `,
                                    bold: true,
                                  },
                                  '; or'
                                ]
                              }
                            ],
                            [
                              {
                                text: [
                                  'whether arising from dealings between',
                                  {
                                    text: ` ${companyShortName} `,
                                    bold: true
                                  },
                                  'and the BORROWER or from any other dealings or proceedings by which',
                                  {
                                    text: ` ${companyShortName} `,
                                    bold: true
                                  },
                                  'may be or become a part of in any manner in regards to the ',
                                  'BORROWER; and '
                                ]
                              }
                            ],
                            [
                              'including all interest, commissions, legal and other costs, charges and expenses'
                            ]
                          ]
                        }
                      ],
                      [
                        'In this Agreement, words importing the singular shall include the plural and vice versa unless otherwise stated.'
                      ]
                    ]
                  }
                ],
                [
  
                ]
              ]
            }
          ],
          [
            {
              text: 'CONTINUING GAURANTEE',
              decoration: 'underline'
            },
            {
              ol: [
                {
                  text: `This guarantee shall be a continuing guarantee and security of all the guaranteed liabilities and shall apply to and secure any ultimate balance due or remaining to ${companyShortName} whether due under the loan request this agreement refers to or otherwise not withstanding liquidation of the BORROWER.`,
                  margin: [0, 0, 0, 10]
                },
              ]
            }
          ],
          [
            {
              text: 'GAURANTEE FOR PAYMENT',
              decoration: 'underline'
            },
            {
              ol: [
                [
                  {
                    text: [
                      {
                        text: ` ${companyShortName} `,
                        bold: true
                      },
                      'shall not be bound to exhaust its recourse against the BORROWER or others or any securities or other guarantees it may at any time hold before being entitled to payment from the GUARANTOR.'    
                    ]
                  }
                ],
                [
                  'Each of the GUARANTOR maybe compelled to pay the total amount of Guaranteed Liabilities and the GUARANTOR renounces all benefits of discussion and division.'
                ]
  
              ]
            }
          ],
          [
            {
              text: 'DATE LIABILITY ARISES',
              decoration: 'underline'
            },
            {
              ol: [
                [
                  {
                    text: [
                      'The GUARANTOR’s liability under this guarantee shall arise forthwith after demand for payment has been made in writing on the undersigned, or if more than one, on any one of them, and such demand shall be deemed to have been effectually made on the day following that on which an envelope containing and such demand addressed to the undersigned or such one of them last known to',
                      {
                        text: ` ${companyShortName} `,
                        bold: true
                      }, 
                      'is posted, postage prepaid in the post office; and the GUARANTOR’s liability shall bear interest from such date at the rate or rates mentioned in paragraph 5 hereof.',
                    ],
                    margin: [0, 0, 0, 10]
                  }
                ]
              ]
            }
          ],
          [
            {
              text: 'INTEREST',
              decoration: 'underline'
            },
            {
              ol: [
                {
                  text: `The rate of interest payable by the GUARANTOR from date of a demand for payment under this guarantee shall be at the rate or rates payable by the BORROWER at the date of such demand and on the several items of indebtedness constituting the guaranteed liabilities. Nothing in this agreement shall prevent ${companyShortName} from including interest payable by the BORROWER in the calculation of interest payable by the GUARANTOR.`,
                  margin: [0, 0, 0, 10]
                }
              ]
            }
          ],
          [
            {
              text: 'DEFAULT',
              decoration: 'underline'
            },
            {
              ol: [
                [
                  {
                    text: [
                      'Upon default in payment of any sum owing by the BORROWER to',
                      {
                        text: ` ${companyShortName} `,
                        bold: true
                      },
                      'at any time,',
                      {
                        text: ` ${companyShortName} `,
                        bold: true
                      },
                      'may treat all guaranteed liabilities as due and payable and may forthwith collect from the GUARANTOR the total amount hereby guaranteed and may apply the sum so collected against and in reduction or settlement of the BORROWER’s debt or may place it to the credit of a special account. Where there are more than one GUARANTORs then',
                      {
                        text: ` ${companyShortName} `,
                        bold: true
                      },
                      'reserves the absolute right to collect from or bring proceedings in regards to all or any portion of the guaranteed liabilities from any of the GUARANTORs or any number of GUARANTORs that',
                      {
                        text: ` ${companyShortName} `,
                        bold: true
                      },            
                      'sees fit.'
                    ],
                    margin: [0, 0, 0, 10]
                  }
                ],
                [
                  {
                    text: [
                      'This guarantee shall be in addition to and not in substitution for any other guarantee or other securities which',
                      {
                        text: ` ${companyShortName} `,
                        bold: true
                      },,
                      'may now or hereinafter hold in respect of the guaranteed liabilities and',
                      {
                        text: ` ${companyShortName} `,
                        bold: true
                      },
                      'shall be under no obligation to marshal in favour of the GUARANTOR any other guarantees or other securities or any moneys or other assets which',
                      {
                        text: ` ${companyShortName} `,
                        bold: true
                      },
                      'may be entitled to receive or may have a claim upon; and no loss or unenforceability of any other guarantees or other securities which',
                      {
                        text: ` ${companyShortName} `,
                        bold: true
                      },
                      'may now or hereinafter hold in respect of the guaranteed liabilities, whether occasioned by the fault of',
                      {
                        text: ` ${companyShortName} `,
                        bold: true
                      },
                      'or otherwise shall in any way limit or lesson the GUARANTOR’s liability. '
                    ],
                    margin: [0, 0, 0, 20]
                  }
                ]
              ]
            },
          ],
          [
            {
              text: 'CONCLUSIVE EVIDENCE',
              decoration: 'underline'
            },
            {
              ol: [
                {
                  text: [
                    ' written statement of a Manager or Assistant Manager of any branch of',
                    {
                      text: ` ${companyShortName} `,
                      bold: true
                    },
                    'at which an account of the BORROWER hereby guaranteed is kept or of a General Manager or Deputy General Manager of',
                    {
                      text: ` ${companyShortName} `,
                      bold: true
                    }, 
                    'as to the amount remaining unpaid to',
                    {
                      text: ` ${companyShortName} `,
                      bold: true
                    },
                    'at any time by the BORROWER, shall, be conclusive evidence and shall, in any event, be prima facie evidence against the GUARANTOR as to the amount remaining unpaid to',
                    {
                      text: ` ${companyShortName} `,
                      bold: true
                    }, 
                    'at such time by the BORROWER '
                  ]
                }

              ]
            }
          ],
          [
            {
              text: 'RIGHT TO VARY',
              decoration: 'underline'
            },
            {
              ol: [
                [
                  {
                    text: `Without prejudice to or in any way limiting or lessening the GUARANTOR’s liability and without obtaining the consent of or giving notice to the GUARANTOR, ${companyShortName} has the sole discretion to:`,
                    margin: [0, 0, 0, 10]
                  },
                ],
                [
                  'discontinue, reduce, increase or otherwise vary the credit of the BORROWER; or'
                ],
                [
                  'grant time, renewals, extensions, indulgences, releases and discharges to and accept compositions from or otherwise deal with the BORROWER and others, including the GUARANTOR and any other GUARANTOR; or'
                ],
                [
                  {
                    text: [
                      'take, abstain from taking or perfecting, vary, exchange, renew, discharge, give up, release on or otherwise deal with securities and guarantees in such manner ',
                      {
                        text: ` ${companyShortName} `,
                        bold: true
                      },
                      'as may see fit; or'
                    ]
                  }
                ],
                [
                  {
                    text: [
                      'apply all moneys received from the BORROWER or others or from securities or guarantees upon such parts of the guaranteed liabilities',
                      { 
                        text: ` ${companyShortName} `,
                        bold: true
                      },
                      'as may see fit and change any such application in whole or in part from time to time.'
                    ]
                  }
                ]
              ]
            }
          ],
          [
            {
              text: 'PAYMENTS IN GROSS',
              decoration: 'underline'
            },
            {
              text: [
                'All dividends, compositions, proceeds of securities valued or payments received by',
                {
                  text:` ${companyShortName} `,
                  bold: true
                }, 
                'from the BORROWER or others, or from estates in respect of guaranteed liabilities shall be regarded for all purposes as payments in gross without any right on the part of the GUARANTOR to claim the benefit thereof in reduction of the liability under this guarantee ',
              ],
              margin: [0, 0, 0, 10]
            },
          ],
          [
            {
              text: 'NO SET-OFF OR COUNTER CLAIM',
              decoration: 'underline'
            },
            {
              text: [
                'Until repayment in full of all the guaranteed liabilities, the GUARANTOR shall not claim any set-off or counter-claim against the BORROWER in respect of any liability of the BORROWER to the GUARANTOR, claim or prove in the Bankruptcy or insolvency of the BORROWER in competition with',
                {
                  text: ` ${companyShortName} `,
                  bold: true
                },
                'or have any right to be subrogated to',
                {
                  text: ` ${companyShortName}.`,
                  bold: true

                }
              ],
              margin: [0, 0, 0, 10]
            }
          ],
          [
            {
              text: 'DEATH, LOSS OF CAPACITY OR CHANGE',
              decoration: 'underline'
            },
            {
              text: 'This guarantee shall not be discharged or otherwise affected by:',
            },
            {
              ol: [
                [
                  {
                    text: 'the death or loss of capacity of the BORROWER;',
                  }
                ],
                [
                  {
                    text: 'any change in the:'
                  },
                  {
                    ol: [
                      ['name or gender of the BORROWER; or'],
                      ['membership of the BORROWER, if the BORROWER is a partnership; or'],
                      ['objects, capital structure or constitution of the BORROWER, if the BORROWER is a corporation; or ']
                    ]
                  }
                ],
                [
                  'the sale of the BORROWER’s business or any part thereof; or ',
                  'the BORROWER being amalgamated with a corporation, but shall, notwithstanding any such event:',
                  {
                    ol: [
                      [
                        'continue to apply to all guaranteed liabilities whether therefore or thereafter incurred; and'
                      ],
                      [
                        'in the case of a change of membership of a BORROWER which is a partnership, this guarantee shall apply to the liabilities of the continuing partnership'
                      ]
                    ]
                  },

                ],
              ]
            }
          ],
          [
            {
              text: 'NO NOTICE OF DEATH, BANKRUPTCY OR LOSS OF CAPACITY',
              decoration: 'underline'
            },
            {
              text: [ 
                'a. All advances, renewals or credits made or granted by',
                {
                  text: ` ${companyName} `,
                  bold: true,
                },
                'purportedly to or for the BORROWER after the death, loss of capacity, bankruptcy or insolvency of the BORROWER, but before',
                { 
                  text: ` ${companyName} `,
                  bold: true,
                },
                'has received notice thereof shall be deemed to form part of the guaranteed liabilities; and, all advances, renewals on credits obtained from',
                {
                  text: ` ${companyName} `,
                  bold: true,
                },
                'purportedly by or on behalf of the BORROWER shall be deemed to form part of the guaranteed liabilities, notwithstanding any lack of limitation or power, incapacity or disability of the BORROWER or of the directors, partners or agents thereof; or that the BORROWER may not be a legal or suitable agent, or any irregularity, defect or informality in the obtaining of such advances, renewals or credits, whether or not',
                {
                  text: ` ${companyName} `,
                  bold: true
                },
                'had knowledge thereof; and any such advance, renewal or credit which may not be recoverable from the undersigned as GUARANTOR(s) shall be recoverable from the undersigned, and if more than one each of them jointly and severally, as principal debtor(s) in respect thereof and shall be paid to',
                {
                  text: ` ${companyName} `,
                  bold: true
                },
                'on demand with interest at the rate or rates set out in paragraph 5 hereof.'
              ],
              margin: [0, 0, 0, 10]
            },
          ],
          [
            {
              text: 'BORROWER’S INDEBTNESS TO GUARANTOR',
              decoration: 'underline'
            },
            {
              ol: [
                [
                  {
                    text: [
                      'All debts and liabilities, present and future, of the BORROWER to the GUARANTOR are hereby postponed to the guaranteed liabilities and this postponement is independent of the guarantee and shall remain in full force and effect until repayment in full to',
                      {
                        text: ` ${companyName} `,
                        bold: true
                      },
                      'of all the guaranteed liabilities, notwithstanding that the liability of the undersigned or any one of them under this guarantee may have been discharged or terminated.'      
                    ]
                  }
                ],
                [
                  'All monies received by the GUARANTOR from BORROWER in respect of any such debts or liabilities shall:',
                  {
                    ol: [

                      [
                        {
                          text: [
                            'be held in trust for', 
                            {
                              text: ` ${companyName} `,
                              bold: true
                            }, 
                            'and'
                          ]
                        }
                      ],
                      [
                        {
                          text: [
                            'forthwith upon receipt the GUARANTOR shall notify',
                            {
                              text: ` ${companyName} `,
                              bold: true
                            },
                            'of the fact of the receipt and the amount thereof, and shall forthwith pay over all monies to the satisfaction of the BORROWER’s indebtedness as',
                            {
                              text: ` ${companyName} `,
                              bold: true
                            },
                            'may instruct.'
                          ]
                        }
                      ]
                    ]
                  }
                ],
                [
                  {
                    text: 'TERMINATION NOTICE',
                    decoration: 'underline'
                  },
                  {
                    text: [
                      'a. The undersigned, or if more than one of them, any one of them or his or their executors or administrators, by giving thirty days’ notice in writing addressed to ',
                      {
                        text: ` ${companyName} ’s `,
                        bold: true
                      },
                      'Legal Advisor at its’ Head Office, may terminate his or their future liability under this guarantee in respect of liabilities of the BORROWER incurred or arising after the expiration of such thirty days, but not in respect of any guaranteed liabilities incurred or arising before the expiration of such thirty days even though not yet matured; provided that notwithstanding receipt of any such notice',
                      {
                        text: ` ${companyName} `,
                        bold: true
                      },
                      'may within such period of thirty days fulfill any requirements of the BORROWER bases on arrangements express, or implied made prior to the expiration of such thirty days and any resulting liabilities shall be covered by this guarantee; and provided further that in the event of the termination of this guarantee as to one or more of the undersigned, if more than on , it shall remain a continuing guarantee as to the other or others of the undersigned.'
                    ],
                    margin: [0, 0, 0, 10]
                  }
                ],
                [
                  {
                    text: 'REPRESENTATION, PROMISES, NON-EXECUTION',
                    decoration: 'underline'
                  },
                  {
                    text: [
                      'This guarantee embodies all the agreements between the parties hereto relative to the guarantee and postponement and none of the parties shall be bound by any representation or promise made by any person relative thereto which is not embodied herein; and it is specifically agreed that ',
                      {
                        text: ` ${companyName} `, 
                        bold: true,
                      },
                      'shall not be bounded by any representations or promises made by the BORROWER to the GUARANTOR. Possession of this instrument by', 
                      {
                        text: ` ${companyName} `,
                        bold: true
                      }, 
                      'shall be conclusive evidence against the GUARANTOR that the instrument was not delivered in escrow or pursuant to any agreements that it should not be effective until any condition precedent or subsequent has been complied with and this guarantee shall be operative and binding notwithstanding the non-execution thereof by any proposed signatory.',
                    ],
                    margin: [0, 0, 0, 10]
                  },
                ],
                [
                  {
                    text: 'JURISDICTION',
                    decoration: 'underline'
                  },
                  {
                    text: 'This guarantee shall be governed in all respects by the laws of Jamaica.',
                    margin: [0, 0, 0, 10]
                  },
                ],
                [
                  {
                    text: 'NO DISCHARGE BY DEATH',
                    decoration: 'underline'
                  },
                  {
                    text: [
                      'a. This guarantee shall not be discharged or affected by the death of the undersigned, or, if more than one of them, of any of them and shall enure to the benefit of and be binding upon ', 
                      {
                        text: `${companyName}, `,
                        bold: true
                      },
                      'its successors and assigns, and the GUARANTOR, his heirs, executors, administrators, successors and assigns as if they had been throughout expressly named herein.'
                    ],
                    margin: [0, 0, 0, 10]
                  },
                ],
                [
                  {
                    text: 'SEVERANCE',
                    decoration: 'underline'
                  },
                  {
                    text: 'if any provision of this present is determined to be void or unenforceable in whole or in part, it shall be deemed not to act or impair any other provision hereof.',
                    margin: [0, 0, 0, 10]
                  },
                ],
                [
                  {
                    text: 'DATA PROTECTION',
                    decoration: 'underline'
                  },
                  {
                    ol: [
                      [
                        {
                          text: [
                            'As far as is reasonably required, for the service being offered by',
                            { 
                              text: ` ${companyName} `,
                              bold: true,
                            },
                            'in regards to the execution and performance of this Agreement and its securities: both the BORROWER and the GUARANTOR hereby consent to the collection, use, disclosure and processing of personal data and information provided by the BORROWER and the GUARANTOR to',
                            {
                              text: ` ${companyName} `,
                              bold: true
                            },
                            'or otherwise obtained.'
                          ]
                        }
                      ],
                      [
                        'Personal data and information reasonably required, in accordance with CLAUSE 19.1.1.1 may be used by or disclosed to, or shared with the following:',
                        {
                          ol: [
                            [
                              {
                                text: [  
                                  'Senior Management and regular employees of the',
                                  { 
                                    text:` ${companyName}’s `,
                                    bold: true
                                  },
                                  'various departments and branches for maintaining of accurate records and financial statements;'
                                ]
                              }
                            ],
                            [
                              'Local Authorities under statutory legislations such as the Credit Reporting Act;'
                            ],
                            [
                              {
                                text: [
                                  'debt collectors pursuant to',
                                  { 
                                    text: ` ${companyName}’s `,
                                    bold: true,
                                  },
                                  'rights of seizure;'
                                ]
                              }
                            ],
                            [
                              'the Court and legal advisors pursuant to enforcement provisions;'
                            ],
                            [
                              'Any other individual in the context of execution and performance of this Agreement and its securities.'
                            ]
                          ]
                        }
                      ]
                    ]
                  },
                ]
              ]
            },
          ]
        ],
        margin: [0,0,0,20]
      },
      {
        text: 'AS WITNESS the hand of the GUARANTOR(s) at',
        margin: [0, 0, 0, 10],
        pageBreak: 'before'
      },
      {
        text: [
          {
            text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
            decoration: 'underline',
          },
          'in the parish of',
          {
            text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
            decoration: 'underline',
          },
          'this',
          {
            text: 'ㅤㅤㅤㅤㅤ',
            decoration: 'underline'
          },
          'day of ',
          {
            text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ ',
            decoration: 'underline'
          },
          '20',
          {
            text: 'ㅤㅤ',
            decoration: 'underline',
          },
        ],
        margin: [0, 0, 0, 40]
      },
      {
        text: 'SIGNED BY THE SAID:',
        margin: [0, 0, 0, 10]
      },
      {
        text: 'IN THE PRESENCE OF:',
        margin: [0, 0, 0, 20]
      },
      {
        text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
        decoration: 'underline',
        margin: [0, 0, 0, 5]
      },
      {
        text: [
          'Name of ',
          {
            text: 'JUSTICE OF THE PEACE',
            bold: true
          },
        ],
        margin: [0, 0, 0, 20]
      },
      {
        text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
        decoration: 'underline',
        margin: [0, 0, 0, 5]
      },
      {
        text: [
          'Signature of ',
          {
            text: 'JUSTICE OF THE PEACE ',
            bold: true,
          },
          'for the parish of:',
        ],
        margin: [0, 0, 0, 10]
      }
    ],

    footer: function (currentPage, pageCount) {
      return {
        text: `Page ${currentPage.toString()} of ${pageCount.toString()}`,
        alignment: 'center'
      };
    }
  };

  return config;
};
